// B2BES [AST-359] - ADD Customization - Part of AST-359 EVO Payments
import { Wallet } from "@auer-steel/Services/AuerSteelApiModels";
import Select from "@insite/mobius/Select";
import * as React from "react";
import translate from "@insite/client-framework/Translate";
import Typography from "@insite/mobius/Typography";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";

export interface ACHWalletDropdownStyles {
    fullWidthGridItem?: GridItemProps;
    errorText?: any;
}

type Props = {
    wallets: Wallet[],
    walletChangeHandler: (e: React.ChangeEvent<HTMLSelectElement>) => void,
    error: string | boolean,
}

export const styles: ACHWalletDropdownStyles = {
    fullWidthGridItem: {
        width: 11,
    },
    errorText: {
        color: "#CD2037",
        weight: 600,
    }
}
const isNonEmptyString = (value: string | undefined) => value !== undefined && value.trim() !== "";

export const ACHWalletsDropdown: React.FC<Props> = (props) => {
    const [selectWalletError, setSelectWalletError] = React.useState("");

    const validateAchWalletId = (achWalletId: string) => {
        const achWalletIdValid = isNonEmptyString(achWalletId);
        setSelectWalletError(!achWalletIdValid ? translate("Select ACH Account is required.") : "");
    }

    return (
        <GridItem {...styles.fullWidthGridItem}>
            <Select
                label={translate("Select ACH Account")}
                id="selectWallet"
                required
                placeholder="Select"
                onChange={props.walletChangeHandler}
            >
                {props.wallets.length !== 0 &&
                    props.wallets.map((item,idx) => {
                        return (
                            <option key={item.PaymentProfileId+idx} value={item.PaymentProfileId}>
                                {item.MaskedCardNumber}
                            </option>
                        );
                    })}
            </Select>
            {props.error && (
                <Typography {...styles.errorText}>
                    {selectWalletError}
                </Typography>
            )}
        </GridItem>
    );
};
